 

<div class="card">
    <slot></slot>
</div>


<style>
.card{
    background-color: #fff;
    padding: 20px;
    border-radius: 6px;
    box-shadow:  0px 2px 4px rgba(0,0,0,0.2);
}

</style>